import type { ComponentSchema } from '../../../../../schema-types'
import { schema as compareSchema } from './compare.schema'
import { schema as productDetailSchema } from './product-detail.schema'
import { schema as shopGridSchema } from './shop-grid.schema'
import { schema as wishlistSchema } from './wishlist.schema'

/** Listing, category, product detail, wishlist and compare pages. */
export const catalogueSchemas: Record<string, ComponentSchema> = {
  'shop-grid': shopGridSchema,
  'product-detail': productDetailSchema,
  wishlist: wishlistSchema,
  compare: compareSchema,
}
